<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'

interface Props {
  options: Array<string>
  associatedIndexes?: Array<number>

  modelValue: number
}

const emit = defineEmits<{
  (e: 'update:modelValue', value: number): void
}>()

const props = withDefaults(defineProps<Props>(), {
  associatedIndexes: undefined,
})

const indexes = computed(() => {
  return (
    props.associatedIndexes ?? new Array(props.options.length).fill(0).map((el, index) => index)
  )
})

const gridStyle = computed(() => `repeat(${props.options.length},1fr)`)

const chosenOption = computed({
  get() {
    return props.modelValue
  },
  set(newValue) {
    emit('update:modelValue', newValue)
  },
})

const buttons = ref(null)

const onButtonPress = (e: Event) => {
  const options = props.options.map(item => item.trim())
  const indx = options.indexOf((e.target as HTMLElement).innerText)

  chosenOption.value = indexes.value[indx >= 0 ? indx : 0]

  //@ts-ignore
  for (let i = 0; i < buttons.value.length; i++) {
    buttons.value[i].classList.remove('button-toggler__btn_active')
  }
  // @ts-ignore
  e.target.classList.add('button-toggler__btn_active')
}

onMounted(() => {
  if (chosenOption.value !== null) {
    buttons.value[Number(chosenOption.value)].classList.add('button-toggler__btn_active')
  }
})
</script>

<template>
  <div class="button-toggler">
    <div v-for="option of options" class="button-toggler__item">
      <button @click="onButtonPress" ref="buttons" class="button-toggler__btn">
        {{ option.trim() }}
      </button>
    </div>
  </div>
  <div></div>
</template>

<style scoped lang="scss">
.button-toggler {
  width: 100%;
  height: 32px;

  background-color: $ui-gray-2;
  border-radius: 8px;
  display: grid;
  grid-template-columns: v-bind(gridStyle);
  justify-content: center;
  align-items: center;
  text-align: center;

  &__item {
    height: 100%;
    position: relative;
  }

  &__btn {
    color: $primary-text;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    @include h5-6;
    transition: all 0.3s ease 0s;

    border-radius: 8px;

    &_active {
      background-color: $primary-green;
      color: $white;
    }
  }
}
</style>
